import { Injectable } from '@angular/core';
import { Unsubscribable } from '@bcf2-shared-pkg-v1/platforms/platform-worker/browser/unsubscribable';
import { BehaviorSubject } from 'rxjs';
import { ModalStandaloneResolverSignalService } from './modal-standalone-resolver-signal.service';

@Injectable({
  providedIn: 'root'
})
export class ModalGeolocationProcessingService extends Unsubscribable {
  public show$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private _modalStandaloneResolverSignal: ModalStandaloneResolverSignalService) {
    super();
    this._init();
  }

  private _init(): void {
    this._sub = this.show$.subscribe(this._modalStandaloneResolverSignal.resolve('geolocation-processing'));
  }
}
